import React from "react"; // eslint-disable-line @typescript-eslint/no-unused-vars
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  AreaChart,
  Area,
  PieChart,
  Pie,
  CartesianGrid,
  XAxis,
  YAxis,
  Legend,
  Tooltip
} from "recharts";

const GraphBlock = ({ type, color, data, width, height, x_column, y_column }) => {
  const keys = Object.keys(data[0]);

  // Normalise x_column — may be a string, an array, or absent
  const xCols = x_column
    ? (Array.isArray(x_column) ? x_column : [x_column])
    : null;

  let effectiveData;
  let dataKey = "";
  let valueKeys = [];

  if (xCols && xCols.length > 1) {
    // Pivot: each selected X column becomes its own category row.
    // Column name → X label, column value → Y value.
    effectiveData = [];
    data.forEach(row => {
      xCols.forEach(col => {
        effectiveData.push({ __x: col, __y: row[col] });
      });
    });
    dataKey = '__x';
    valueKeys = ['__y'];
  } else {
    effectiveData = data;
    dataKey = xCols ? xCols[0] : '';
    valueKeys = y_column ? [y_column] : [];
    // Fall back to auto-detect when no explicit columns set
    if (!dataKey || !valueKeys.length) {
      keys.forEach((key) => {
        if (!dataKey && typeof data[0][key] === 'string') dataKey = key;
        if (!y_column && typeof data[0][key] === 'number') valueKeys.push(key);
      });
    }
  }

  switch (type) {
    case "pie":
      return (
        <PieChart width={width} height={height}>
          <Pie
            data={effectiveData}
            dataKey={valueKeys[0]}
            nameKey={dataKey}
            cx="50%"
            cy="50%"
            outerRadius={100}
            fill="#82ca9d"
          />
        </PieChart>
      );
    case "line":
      return (
        <LineChart data={effectiveData} margin={{ left: 10, right: 10 }} width={width} height={height}>
          <CartesianGrid vertical={false} strokeOpacity={0.3} />
          <XAxis dataKey={dataKey} type="category" />
          <YAxis />
          <Tooltip />
          <Legend />
          {valueKeys.map((value, index) => (
            <Line
              type="monotone"
              key={value}
              dataKey={value}
              name={value === '__y' ? 'Value' : value}
              stroke={color[index % color.length]}
              activeDot={8}
            />
          ))}
        </LineChart>
      );
    case "bar":
      return (
        <BarChart
          data={effectiveData}
          margin={{ left: 20, right: 20, top: 10, bottom: 10 }}
          width={width}
          height={height}
        >
          <CartesianGrid vertical={false} strokeOpacity={0.3} />
          <XAxis dataKey={dataKey} type="category" />
          <YAxis />
          <Tooltip />
          <Legend />
          {valueKeys.map((value, index) => (
            <Bar key={value} dataKey={value} name={value === '__y' ? 'Value' : value} fill={color[index % color.length]} />
          ))}
        </BarChart>
      );
    case "area":
      return (
        <AreaChart data={effectiveData} margin={{ left: 10, right: 10 }} width={width} height={height}>
          <CartesianGrid vertical={false} strokeOpacity={0.3} />
          <XAxis dataKey={dataKey} type="category" />
          <YAxis />
          <Tooltip />
          <Legend />
          {valueKeys.map((value, index) => (
            <Area
              type="monotone"
              key={value}
              dataKey={value}
              name={value === '__y' ? 'Value' : value}
              stackId="1"
              fill={color[index % color.length]}
              stroke={color[index % color.length]}
            />
          ))}
        </AreaChart>
      );
    default:
      return null;
  }
};

export default GraphBlock;
